
export interface IQuestTransactionRequest {
    id: number,
    donorCenter: string,
    donorCenterAlias: string,
    donorAlias: string,
    donorFirstName: string,
    donorLastName: string,
    donorEmail: string,
    fileName: string,
    completedDate: string
}